// extracted by mini-css-extract-plugin
export default {"page":"page_InfoPage-module_1kjWb"};